import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlEstimateVoid } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'
const apiUrl = makeUrlEstimateVoid()

const useEstimateVoid = () => {
  const [errorVoidEstimate, setErrorVoidEstimate] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const voidEstimate = async (_id: string, cause: string) => {
    setLoading(true)

    try {
      const by = userData?.profile?._id ?? ''
      await customPost(apiUrl, { _id, cause, by })

      setErrorVoidEstimate(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorVoidEstimate(err)
      } else {
        setErrorVoidEstimate(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorVoidEstimate, loading, voidEstimate }
}
export default useEstimateVoid
